import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "additional-work-types__list"
}
const _hoisted_2 = ["disabled", "onClick"]
const _hoisted_3 = {
  key: 1,
  class: "additional-work-types__controls"
}
const _hoisted_4 = ["disabled"]

import { computed, ref } from "vue";
import { useTaskStore } from "@/features/tasks/task.store";
import type { ITaskData, ITaskWorkType } from "@/features/tasks/task.types";
import type { IWorkType } from "@/features/work-types/work-type.types";
import CustomSearchDropdown from "@/components/custom/CustomSearchDropdown.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TaskAdditionalWorkTypes',
  props: {
    task: {},
    workTypes: {},
    canEdit: { type: Boolean }
  },
  emits: ["updated"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const taskStore = useTaskStore();

const selectedWorkTypeId = ref("");
const saving = ref(false);
const workTypeSearch = ref("");

const additionalWorkTypes = computed<ITaskWorkType[]>(() =>
  (props.task.work_types || []).filter((item) => !item.is_primary)
);

const availableWorkTypes = computed(() => {
  const existingIds = new Set(
    (props.task.work_types || []).map((item) => item.id)
  );

  existingIds.add(props.task.work_type_id);

  const query = workTypeSearch.value.trim().toLowerCase();

  return props.workTypes
    .filter((item) => item.is_active && !existingIds.has(item.id))
    .filter((item) => item.name.toLowerCase().includes(query));
});

const additionalWorkTypeOptions = computed(() =>
  availableWorkTypes.value.map((item) => ({
    value: item.id,
    name: item.name,
    app: String(item.base_points),
  }))
);

const editable = computed(
  () => props.canEdit && props.task.status === "in_progress"
);

async function addWorkType() {
  if (!editable.value || saving.value || !selectedWorkTypeId.value) {
    return;
  }

  const success = await taskStore.addTaskWorkType(
    saving,
    props.task.id,
    selectedWorkTypeId.value
  );

  if (success) {
    selectedWorkTypeId.value = "";
    emit("updated");
  }
}

async function removeWorkType(workTypeId: string) {
  if (!editable.value || saving.value) {
    return;
  }

  const success = await taskStore.removeTaskWorkType(
    saving,
    props.task.id,
    workTypeId
  );

  if (success) {
    emit("updated");
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "additional-work-types",
    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
  }, [
    (additionalWorkTypes.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(additionalWorkTypes.value, (workType) => {
            return (_openBlock(), _createElementBlock("div", {
              key: workType.id,
              class: "additional-work-types__item"
            }, [
              _createElementVNode("span", null, _toDisplayString(workType.name), 1),
              (editable.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "additional-work-types__remove",
                    disabled: saving.value,
                    title: "Remove additional work type",
                    onClick: _withModifiers(($event: any) => (removeWorkType(workType.id)), ["stop"])
                  }, " × ", 8, _hoisted_2))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (editable.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(CustomSearchDropdown, {
            modelValue: selectedWorkTypeId.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedWorkTypeId).value = $event)),
            items: additionalWorkTypeOptions.value,
            label: "Add work type...",
            position: "bottom",
            dropdownFullWidth: "",
            fullWidth: "",
            clearable: "",
            maxWidth: "100%",
            disabled: saving.value,
            onSearch: _cache[1] || (_cache[1] = (value) => (workTypeSearch.value = value))
          }, null, 8, ["modelValue", "items", "disabled"]),
          _createElementVNode("button", {
            type: "button",
            class: "additional-work-types__add",
            disabled: saving.value || !selectedWorkTypeId.value,
            onClick: _withModifiers(addWorkType, ["stop"])
          }, _toDisplayString(saving.value ? "..." : "+"), 9, _hoisted_4)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})